import { render } from "./PrestasiIpendaftaran.vue?vue&type=template&id=91235c78"
import script from "./PrestasiIpendaftaran.vue?vue&type=script&lang=js"
export * from "./PrestasiIpendaftaran.vue?vue&type=script&lang=js"

import "./PrestasiIpendaftaran.vue?vue&type=style&index=0&id=91235c78&lang=css"
import "./PrestasiIpendaftaran.vue?vue&type=style&index=1&id=91235c78&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__